<script setup lang="ts">
defineOptions({
	name: 'HeroLegalContent',
})

interface Props {
	title?: string
	description?: string
	isUseSlotDesciption?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	title: '',
	description: '',
	isUseSlotDesciption: false,
})
</script>

<template>
	<div class="flex flex-col items-center justify-center bg-primary-800 w-full py-12 sm:py-24 px-4 sm:px-0">
		<div class="max-w-[930px]">
			<div class="flex flex-col items-center gap-7">
				<div class="bg-white/10 rounded-full p-3.5 sm:p-5 size-16 sm:size-24 flex items-center justify-center">
					<slot name="icon" />
				</div>

				<h1 class="text-3xl sm:text-[40px] font-semibold text-white text-center">{{ props.title }}</h1>

				<div
					v-if="props.isUseSlotDesciption"
					class="text-lg sm:text-xl text-[#DBEAFE] text-center tracking-tight font-normal"
				>
					<slot name="description" />
				</div>
				<div
					v-else
					class="text-lg sm:text-xl text-[#DBEAFE] text-center tracking-tight font-normal"
					v-html="props.description"
				></div>
			</div>
		</div>
	</div>
</template>
